import ApprovalWorkbench from '../features/approval/ApprovalWorkbench';

/**
 * 审批工作台页 —— 渲染 p3-detail 的审批工作台。
 */
export default function ApprovalPage() {
  return <ApprovalWorkbench />;
}
